.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  max-width: 600px;
  padding: 0 20px;
}

.page {
  margin-top: 140px;
}

.section {
  margin-top: 32px;
  margin-bottom: 32px;
  padding: 32px 20px;
  border: 1px solid var(--box-border-color);
  border-radius: 8px;
  background: var(--box-background);
}

.icon {
  background: var(--muted-icon-color);
  color: white;
  padding: 14px;
  font-size: 40px;
  border-radius: 5px;
  margin-bottom: 20px;
}

.section .icon {
  font-size: 28px;
  padding: 10px;
  margin-bottom: 16px;
}

.title {
  font-weight: 600;
  margin: 0 0 16px;
  font-size: var(--font-size-title);
  color: var(--main-text);
}

.section .title {
  font-size: var(--font-size-subtitle);
  margin-bottom: 8px;
}

.description {
  margin: 0;
  color: var(--body-text);
  font-size: var(--font-size-body);
  line-height: 1.5;
}

.action {
  margin-top: 24px;
}

.diagnostic {
  margin: 20px 0 0;
  font-size: 12px;
  color: var(--muted-text);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  word-break: break-all;
}
